/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalAuthPlatform
 */
export interface PalAuthPlatform {
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatform
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PalAuthPlatform
     */
    name: string;
}

/**
 * Check if a given object implements the PalAuthPlatform interface.
 */
export function instanceOfPalAuthPlatform(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function PalAuthPlatformFromJSON(json: any): PalAuthPlatform {
    return PalAuthPlatformFromJSONTyped(json, false);
}

export function PalAuthPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalAuthPlatform {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function PalAuthPlatformToJSON(value?: PalAuthPlatform | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}

